(function() {
  'use strict';
   angular
    .module('webAgro1App')
    .directive('painelMaquinas', PainelMaquinas);
   function PainelMaquinas() {
    return {
      restrict: 'E',
      controller: 'PainelMaquinasCtrl',
      controllerAs: 'maquinas',
      templateUrl: 'views/propriedade/painel-maquinas.html'
    };
  }
}());
